import {
  applyMiddleware,
  combineReducers,
  createStore,
} from 'redux';
import thunk from 'redux-thunk';
import {loggerMiddleware} from 'src/pages/scheduleCallback/store/enhancers/logger';
import {channelTracking} from 'src/pages/scheduleCallback/store/enhancers/channelTracking';
import {app} from 'src/pages/scheduleCallback/store/reducers/app';
import {account} from 'src/shared/account/reducers';
import {auth} from 'src/shared/auth/reducers';
import {config} from 'src/shared/config/reducers';
import {currentBillSummary} from 'src/shared/currentBillSummary/reducers';
import {currentView} from 'src/shared/currentView/reducers';
import {datacast} from 'src/shared/datacast/reducers';
import {events} from 'src/shared/events/middleware';
import {history} from 'src/shared/history/middleware';
import {
  outageConsolidated,
  outages,
} from 'src/shared/outages/reducers';
import {params} from 'src/shared/params/reducers';
import {phtTimeline} from 'src/shared/phtTimeline/reducers';
import {redirect} from 'src/shared/redirect/middleware';
import {redirectUrl} from 'src/shared/redirect/reducers';
import {resourceStatus} from 'src/shared/resourceStatus/reducers';
import {user} from 'src/shared/user/reducers';
import {compose} from 'src/shared/utils/compose';

const reducer = combineReducers({
  account,
  app,
  auth,
  config,
  currentBillSummary,
  currentView,
  datacast,
  outageConsolidated,
  outages,
  params,
  phtTimeline,
  redirectUrl,
  resourceStatus,
  user,
});

export const store = createStore(
  reducer,
  compose(
    applyMiddleware(
      thunk,
      history,
      redirect,
      loggerMiddleware,
      channelTracking,
      events
    )
  )
);
